export default __webpack_public_path__ + "static/media/pollenNutrinellas.21648e16.jpeg";